import React from "react";

function bucket(score) {
  if (score == null) return "";
  if (score >= 70) return "good";
  if (score >= 50) return "warn";
  return "bad";
}

export function HealthBadge({ score, size = "md" }) {
  if (score == null) return <span className="health-badge">— no score yet</span>;
  const cls = `health-badge ${bucket(score)}`;
  return (
    <span className={cls}>
      <strong>{score}</strong>
      <span className="subtle">/ 100</span>
    </span>
  );
}

export function HealthSubscores({ snapshot }) {
  if (!snapshot) return null;
  const rows = [
    ["Visibility", snapshot.visibility_score],
    ["Engagement", snapshot.engagement_score],
    ["Conversion", snapshot.conversion_score],
    ["GEO", snapshot.geo_score],
    ["Site", snapshot.site_health_score],
  ];
  return (
    <div className="subscores">
      {rows.map(([label, val]) => (
        <div key={label} className="subscore">
          <div className="label">{label}</div>
          <div className="value">{val ?? "—"}</div>
        </div>
      ))}
    </div>
  );
}

export function HealthBig({ snapshot }) {
  if (!snapshot) return <div className="empty">No health score yet</div>;
  return (
    <div>
      <div className="score-big">
        {snapshot.overall_score}
        <small> / 100</small>
      </div>
      <div className="subtle">as of {snapshot.date}</div>
      <HealthSubscores snapshot={snapshot} />
    </div>
  );
}
